import { render, staticRenderFns } from "./LibrusGoIcon.vue?vue&type=template&id=50881992&scoped=true"
import script from "./LibrusGoIcon.vue?vue&type=script&lang=js"
export * from "./LibrusGoIcon.vue?vue&type=script&lang=js"
import style0 from "./LibrusGoIcon.vue?vue&type=style&index=0&id=50881992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50881992",
  null
  
)

export default component.exports